export default __webpack_public_path__ + "static/media/full_color_brain.dabb7cdf.png";